export default {
  itemSelector: '[data-type="preview"] [data-vid]',
};


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/clip-list/default-configs.js
 **/